export default {
  id: 4,
  getFormTypeInputFields: () => [
    'experienceFields',
    {
      name: 'valid_driver_license',
      options: 'yes-no',
      validation: {
        required: 'Valid driver license field is required',
      },
      show: fields => (fields.valid_driver_license || '').toLowerCase() === 'yes',
    },
  ],
};
